import { formatRrule } from './formatRrule';

/** A scheduled automation's `ahoy_schedule` value: an RFC 5545 rrule anchored in `tz`. */
export interface ScheduleValue {
  rrule: string;
  dtstart?: string;
  tz?: string;
}

/** Whether an untyped property value is a schedule we can describe. */
export function isScheduleValue(value: unknown): value is ScheduleValue {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as { rrule?: unknown }).rrule === 'string' &&
    (value as { rrule: string }).rrule.length > 0
  );
}

/** One-line description of a schedule, e.g. "Weekly on Mon, Fri at 09:00 · Europe/Dublin". */
export function formatScheduleValue(value: ScheduleValue): string {
  const described = formatRrule(value.rrule);
  return value.tz ? `${described} · ${value.tz}` : described;
}
